export const firstTableData = [
  [
    {
      content: '重组抗体表达服务包括双链抗体、全长单链抗体、VHH-His、VHH-FC、Fab等',
      span: 10
    },
    {
      content: 'HEK293/CHO',
      span: 10
    },
    {
      content: 'Tsingke-006-3',
    },
    {
      content: '10 mL',
    },
    {
      //content: '约2周， 最快一周即可交付抗体',
      content: '1周~2周交付',
      span: 10
    },
    {
      content: '询价',
      span: 10
    },
  ],
  [
    { content: 'Tsingke-006-4', },
    { content: '20 mL', }
  ],
  [
    { content: 'Tsingke-006-5', },
    { content: '30 mL', }
  ],
  [
    { content: 'Tsingke-006-6', },
    { content: '40 mL', }
  ],
  [
    { content: 'Tsingke-006-7', },
    { content: '50 mL', }
  ],
  [
    { content: 'Tsingke-006-8', },
    { content: '100 mL', }
  ],
  [
    { content: 'Tsingke-006-9', },
    { content: '200 mL', }
  ],
  [
    { content: 'Tsingke-006-10', },
    { content: '500 mL', }
  ],
  [
    { content: 'Tsingke-006-11', },
    { content: '1000 mL', }
  ],
  [
    { content: 'Tsingke-006-12', },
    { content: '>1 L', }
  ],
]

export const secondTableData = [
  [
    {
      content: '大肠杆菌表达系统标准服务',
      span: 6
    },
    {
      content: 'Tsingke-001',
      span: 6
    },
    {
      content: '密码子优化，基因合成',
      span: 1
    },
    {
      content: '1~2周',
      span: 2
    },
  ],
  [
    {
      content: '亚克隆',
      span: 1
    },
  ],
  [
    {
      content: '表达测试与纯化（多种条件优化）',
      span: 1
    },
    {
      content: '2~3周',
      span: 1
    },
  ],
  [
    {
      content: '干冰运输样品',
      span: 1
    },
    {
      content: '/',
      span: 1
    },
  ],
  [
    {
      content: '实验报告',
      span: 1
    },
    {
      content: '/',
      span: 1
    },
  ],
  [
    {
      content: '合计',
      span: 1
    },
    {
      content: '3~5周',
      span: 1
    },
  ],
  [
    {
      content: '枯草芽孢杆菌表达系统',
      span: 7
    },
    {
      content: 'Tsingke-002',
      span: 7
    },
    {
      content: '密码子优化，基因合成',
      span: 1
    },
    {
      content: '1~2周',
      span: 2
    },
  ],
  [
    {
      content: '亚克隆',
      span: 1
    },
  ],
  [
    {
      content: '表达纯化测试',
      span: 1
    },
    {
      content: '2~3周',
      span: 1
    },
  ],
  [
    {
      content: '1 L发酵纯化',
      span: 1
    },
    {
      content: '1~2周',
      span: 1
    },
  ],
  [
    {
      content: '干冰运输样品',
      span: 1
    },
    {
      content: '/',
      span: 1
    },
  ],
  [
    {
      content: '实验报告',
      span: 1
    },
    {
      content: '/',
      span: 1
    },
  ],
  [
    {
      content: '合计',
      span: 1
    },
    {
      content: '4~7周',
      span: 1
    },
  ],
  [
    {
      content: '酵母表达系统',
      span: 9
    },
    {
      content: 'Tsingke-003',
      span: 9
    },
    {
      content: '密码子优化，基因合成',
      span: 1
    },
    {
      content: '1~2周',
      span: 2
    },
  ],
  [
    {
      content: '亚克隆',
      span: 1
    },
  ],
  [
    {
      content: '抗生素筛选',
      span: 1
    },
    {
      content: '1周',
      span: 1
    },
  ],
  [
    {
      content: '表达小试阶段（挑2个克隆摇瓶做甲醇浓度和诱导时间的优化）',
      span: 1
    },
    {
      content: '1~2周',
      span: 1
    },
  ],
  [
    {
      content: '纯化测试（最优克隆+最优表达条件100 mL表达纯化）',
      span: 1
    },
    {
      content: '1~2周',
      span: 1
    },
  ],
  [
    {
      content: '1 L发酵纯化',
      span: 1
    },
    {
      content: '1~2周',
      span: 1
    },
  ],
  [
    {
      content: '干冰运输样品',
      span: 1
    },
    {
      content: '/',
      span: 1
    },
  ],
  [
    {
      content: '实验报告',
      span: 1
    },
    {
      content: '/',
      span: 1
    },
  ],
  [
    {
      content: '合计',
      span: 1
    },
    {
      content: '6~9周',
      span: 1
    },
  ],
  [
    {
      content: '昆虫表达系统',
      span: 9
    },
    {
      content: 'Tsingke-004',
      span: 9
    },
    {
      content: '密码子优化，基因合成',
      span: 1
    },
    {
      content: '1~2周',
      span: 1
    },
  ],
  [
    {
      content: '亚克隆',
      span: 1
    },
    {
      content: '',
      span: 1
    },
  ],
  [
    {
      content: 'P1代病毒生产及表达测试（质粒转化，菌生长，蓝白斑，提质粒，转染，P1表达测试，SDS分析和/或WB分析）',
      span: 1
    },
    {
      content: '2~3周',
      span: 1
    },
  ],
  [
    {
      content: 'P2代病毒生产及表达条件优化（P2病毒生产，MOI测试，SDS分析和/或WB分析）',
      span: 1
    },
    {
      content: '2~3周',
      span: 1
    },
  ],
  [
    {
      content: '200 mL表达纯化测试及蛋白样品交付',
      span: 1
    },
    {
      content: '1周',
      span: 1
    },
  ],
  [
    {
      content: '1 L放大与纯化',
      span: 1
    },
    {
      content: '1~2周',
      span: 1
    },
  ],
  [
    {
      content: '干冰运输样品',
      span: 1
    },
    {
      content: '/',
      span: 1
    },
  ],
  [
    {
      content: '实验报告',
      span: 1
    },
    {
      content: '/',
      span: 1
    },
  ],
  [
    {
      content: '合计',
      span: 1
    },
    {
      content: '7~10周',
      span: 1
    },
  ],
  [
    {
      content: '哺乳动物表达系统',
      span: 7
    },
    {
      content: 'Tsingke-005',
      span: 7
    },
    {
      content: '密码子优化，基因合成',
      span: 1
    },
    {
      content: '1~2周',
      span: 2
    },
  ],
  [
    {
      content: '亚克隆',
      span: 1
    },
  ],
  [
    {
      content: '表达测试（80 mL）',
      span: 1
    },
    {
      content: '1~2周',
      span: 1
    },
  ],
  [
    {
      content: '1 L放大与纯化',
      span: 1
    },
    {
      content: '1~2周',
      span: 1
    },
  ],
  [
    {
      content: '干冰运输样品',
      span: 1
    },
    {
      content: '/',
      span: 1
    },
  ],
  [
    {
      content: '实验报告',
      span: 1
    },
    {
      content: '/',
      span: 1
    },
  ],
  [
    {
      content: '合计',
      span: 1
    },
    {
      content: '3~6周',
      span: 1
    },
  ],
]

export const thirdTableData = [
  [
    {
      content: '大肠杆菌表达系统\n（Escherichia coli）'
    },
    {
      content: '表达水平高；\n低成本；\n简单的培养条件；\n生产迅速；\n可拓展性强；\n转化操作简单；\n蛋白表达可以通过多个参数进行优化。'
    },
    {
      content: '蛋白折叠性较差（包括细菌蛋白）；\n易形成包涵体；\n低效的体外折叠可能抵消优势；\n与真核生物不同密码子体系；\n无翻译后修饰；\n内毒素高。'
    },
    {
      content: '重组蛋白的生产（酶，对活性要求不高的蛋白）'
    },
  ],
  [
    {
      content: '毕赤酵母表达系统\n（Pichia pastoris）'
    },
    {
      content: '表达水平高；\n低成本；\n简单的培养条件；\n生产迅速；\n可拓展性强；\n分泌蛋白或细胞内表达的良好选择；\n蛋白分泌高效且允许简单纯化；\n广泛的翻译后修饰；\nN-端糖基化能力优于酿酒酵母；\n低内毒素。'
    },
    {
      content: '使用甲醇作为诱导剂具有一定危害；\n糖基化修饰仍然不同于哺乳动物细胞。'
    },
    {
      content: '重组蛋白的生产（酶，有活性要求且成本低一些的蛋白）'
    },
  ],
  [
    {
      content: '哺乳动物表达系统'
    },
    {
      content: '较高的表达水平；\n中度的可扩展性；\n细胞的悬浮培养特性可大规模生产；\n有效的蛋白折叠；\n适合分泌蛋白；\n充分的翻译后修饰；\n低内毒素。'
    },
    {
      content: '培养基昂贵；\n复杂的生长条件。'
    },
    {
      content: '重组蛋白的生产（药物蛋白生产，糖蛋白，细胞因子，抗体等）'
    },
  ],
  [
    {
      content: '杆状病毒浸染后的昆虫细胞（杆状病毒-昆虫细胞表达系统）'
    },
    {
      content: '表达水平高（特别是细胞内蛋白）；\n较快的生长速度；\n有效的细胞折叠；\n中度可扩展性；\n广泛的翻译后修饰；\n糖基化与哺乳动物细胞类似；\n相对容易地酶促的去糖基化（对于蛋白结构测定有利）；\n低内毒素。'
    },
    {
      content: '培养基昂贵；\n需要大量的病毒；\n亲肽的分泌通路低效；\n糖基化仍然不同于哺乳动物细胞；\n病毒侵染会导致细胞裂解和潜在的表达蛋白降解。'
    },
    {
      content: '重组蛋白的生产（跨膜蛋白，激酶，大分子量蛋白，病毒/昆虫来源的蛋白）'
    },
  ],
]



// WEBPACK FOOTER //
// ./src/views/products/recombinant-cells-protein-expression/constants.js